import Vue from 'vue'
import { Backtop,Tooltip,Button,Input,FormItem,Form,Radio,RadioGroup,Card,Message,Pagination,Row,Col,Image,Dropdown,DropdownMenu,DescriptionsItem } from 'element-ui'

Vue.prototype.$message = Message;

Vue.use(Button)
Vue.use(Input)
Vue.use(FormItem)
Vue.use(Form)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Card)
Vue.use(Pagination)
Vue.use(Row)
Vue.use(Col)
Vue.use(Image)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DescriptionsItem)
Vue.use(Tooltip)
Vue.use(Backtop)

